import React from 'react';
import { Field,FieldProps } from 'formik';
import { TextField } from '@mui/material';

interface Props {
  label: string;
  name: string;
  placeholder: string;
  isRequired: boolean;
  errorMessage: string;
  onChange:(field:any)=>void;
  formField:any
}

const ShortText: React.FC<Props> = ({ label, name, placeholder, isRequired, errorMessage,onChange,formField}) => (
  <Field name={name}>
    {({ field, meta,form }:FieldProps) => (
      <TextField
        {...field}
        label={`${label} ${isRequired ? "*":""}`}
        placeholder={placeholder}
        error={meta.touched && !!meta.error}
        helperText={meta.touched && meta.error ? errorMessage : ''}
        fullWidth
        onChange={(e:any)=>{
          form.setFieldValue(name,e.target.value);
          onChange({...formField,value:e.target.value})}}
      />
    )}
  </Field>
);

export default ShortText;
